// extracted by mini-css-extract-plugin
export var fontBold = "tobREe0KBETflI9HHw_n";
export var fontMedium = "AEoBLcoMoeKt9qj8JTn1";
export var fontRegular = "A2nBq70z2FtXYjZlgFpx";
export var fontSemiBold = "gDhsacv7BHnV8L6hi3oQ";